export default {"src":"/_next/static/media/pen_edit_icon.9acf9e07.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};